<template>
  <div class="c-pc-tab">
    <ul class="tab-items">
      <li
        v-if="template.meeting.tab_1_p.display.value"
        :title="template.meeting.tab_1_p.text.value"
        :class="{ active: type == 'introduce' }"
        @click="changeTab('introduce')"
      >
        <a
          ><b>{{ template.meeting.tab_1_p.text.value }}</b></a
        >
      </li>
      <li
        v-if="template.meeting.tab_2_p.display.value"
        :title="template.meeting.tab_2_p.text.value"
        :class="{ active: type == 'schedule' }"
        @click="changeTab('schedule')"
      >
        <a
          ><b>{{ template.meeting.tab_2_p.text.value }}</b></a
        >
      </li>
      <li
        v-if="template.meeting.tab_3_p.display.value"
        :title="template.meeting.tab_3_p.text.value"
        :class="{ active: type == 'guests' }"
        @click="changeTab('guests')"
      >
        <a
          ><b>{{ template.meeting.tab_3_p.text.value }}</b></a
        >
      </li>
      <li
        v-if="template.meeting.tab_4_p.display.value"
        :title="template.meeting.tab_4_p.text.value"
        :class="{ active: type == 'expand' }"
        @click="changeTab('expand')"
      >
        <a
          ><b>{{ template.meeting.tab_4_p.text.value }}</b></a
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { mixinsTemplate } from "../../common/mixinsTemplate";
import { $subscriber } from "fire-wind-water";
import webinarService from "../../services/webinar";
import { tenantId } from "../../common/sbase";
export default {
  name: "Tab",
  mixins: [mixinsTemplate],
  data() {
    return {
      type: "introduce",
      webinarInfo: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (this.$route.name == "Introduce") {
        this.type = "introduce";
      } else if (this.$route.name == "Schedule") {
        this.type = "guests";
      } else if (this.$route.name == "Guests") {
        this.type = "guests";
      } else {
        this.type = "expand";
      }
      $subscriber.subscribe("webinarInfo.meeting", data => {
        this.webinarInfo = data;
      });
    },
    changeTab(tab) {
      this.$router.push("/pc/meeting/" + tab);
      this.type = tab;
    }
  }
};
</script>

<style scoped></style>
